import { useMutation } from "@apollo/client";

import { USER_GET_BY_ID } from "~/modules/user/api/useUserGetById";

import { COURSE_GET_ALL } from "../../CourseListRoute/api/useCourseListRoute_GetAll";
import { CourseEditRoute_UserDeleteDocument } from "../mutations.generated";

export default function useUserCourseDelete() {
    const [deleteCourseMutation, { loading, error, data }] = useMutation(CourseEditRoute_UserDeleteDocument, {
        refetchQueries: [USER_GET_BY_ID, COURSE_GET_ALL],
    });

    const deleteUserCourse = async (input: { userId: string; courseId: string }): Promise<void> => {
        await deleteCourseMutation({
            variables: { input },
        });
    };

    return {
        loading,
        error,
        data: data?.userCourseDelete,
        deleteUserCourse,
    };
}
